import { CalendarHolidaysRepository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: CalendarHolidaysRepository): Interactor {
  return ({ planzone, calendarHolidays, nextCalendarHolidays }) =>
    present(
      repository
        .editCalendarHolidays(planzone, calendarHolidays, nextCalendarHolidays)
        .then((updatedCalendarHolidays) => ({
          planzone,
          calendarHolidays: updatedCalendarHolidays,
        }))
        .catch(() => Promise.reject({ planzone, calendarHolidays })),
    );
}

export type { Interactor };

export { createInteractor };
